// extracted by mini-css-extract-plugin
export default {"left":"left--S6D6T","mobile":"mobile--iifvN","desktop":"desktop--oq0Jo"};